import { FetchError, FetchSuccess, fetchV3 } from "..";
import { getEventId } from "Router/RoutesUtils";

export const getEvent = async () => {
  const eventId = getEventId();
  try {
    const res = await fetchV3(
      `event-configs/event-theme-config/${eventId}`,
      null,
      {
        eventTarget: "url",
        hasSubpath: true,
      },
    );

    return new FetchSuccess(res);
  } catch (error) {
    throw new FetchError(error, "Failed to get event theming");
  }
};

export const updateTheme = async (body: any): Promise<FetchSuccess> => {
  const eventId = getEventId();
  try {
    const res = await fetchV3(
      `event-configs/update-theme/${eventId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          event_id: eventId,
          event_config: body?.event,
        }),
      },
      {
        eventTarget: "url",
        hasSubpath: true,
      },
    );

    return new FetchSuccess(res);
  } catch (error) {
    throw new FetchError(error, "Failed to update event theme");
  }
};

export const getEventThemeLogos = async (eventId: string) => {
  try {
    const res = await fetchV3(`events/${eventId}/theme-logos`, null, {
      hasSubpath: false,
    });

    return new FetchSuccess(res);
  } catch (error) {
    throw new FetchError(error, "Failed to get event theme logos");
  }
};
